import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Nauru: Country = {
    identifier: "Nauru",
    name: "Nauru",
    countryCode: "NR",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇳🇷",
    svgPath: "m 943.46275,464.3614 -0.055,0.096 -0.064,-0.012 -0.026,-0.064 0.019,-0.068 0.071,-0.027 0.047,0.021 z",
}
